export default {
  null_option: 'Without {{name}}',
  description: 'Choose your {{name}}',
};
